var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00202734 5.9906C0.00163631 5.79067 0.0713504 5.59693 0.199067 5.44299L4.48255 0.309123C4.78536 -0.0547476 5.32618 -0.104549 5.6905 0.197889C6.05482 0.500327 6.10468 1.04048 5.80187 1.40435L1.96386 5.9906L5.6648 10.5768C5.80853 10.7536 5.87578 10.9803 5.85166 11.2068C5.82754 11.4332 5.71404 11.6407 5.53629 11.7833C5.35822 11.9417 5.1221 12.0188 4.88472 11.9961C4.64735 11.9734 4.4302 11.8528 4.28551 11.6635L0.147666 6.52965C0.0401367 6.37129 -0.011141 6.18149 0.00202734 5.9906Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.9b91667c6f6aba3fb57b626e0c32078a.svg";
export { ForwardRef as ReactComponent };